export default __webpack_public_path__ + "static/media/Minicard_2s.8c0b1837.svg";